import React, { useState } from 'react';
import BlockDrawer from './BlockDrawer';
import './FlowBlock.css';

const FlowBlock = ({ step, onUpdate, onDelete }) => {
    const [showDrawer, setShowDrawer] = useState(false);

    const getBlockIcon = (type) => {
        switch (type) {
            case 'email':
                return '📧';
            case 'delay':
                return '⏰';
            default:
                return '⚡';
        }
    };

    const getBlockColor = (type) => {
        switch (type) {
            case 'email':
                return '#007bff';
            case 'delay':
                return '#ffc107';
            default:
                return '#6c757d';
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'completed':
                return '#28a745';
            case 'error':
                return '#dc3545';
            case 'pending':
                return '#6c757d';
            default:
                return '#6c757d';
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case 'completed':
                return 'Completed';
            case 'error':
                return 'Error';
            case 'pending':
                return 'Pending';
            default:
                return 'Pending';
        }
    };

    const getBlockDetails = () => {
        switch (step.type) {
            case 'email':
                return step.config.subject || 'No subject';
            case 'delay':
                return `Wait ${step.config.duration} ${step.config.unit}`;
            default:
                return step.title;
        }
    };

    return (
        <>
            <div 
                className="flow-block"
                onClick={() => setShowDrawer(true)}
                style={{ borderLeftColor: getBlockColor(step.type) }}
            >
                <div className="block-content">
                    <div className="block-icon">
                        {getBlockIcon(step.type)}
                    </div>
                    <div className="block-info">
                        <div className="block-title">{step.title}</div>
                        <div className="block-details">{getBlockDetails()}</div>
                    </div>
                    <div className="block-actions">
                        <div 
                            className="block-status"
                            style={{ backgroundColor: getStatusColor(step.status) }}
                        >
                            {getStatusText(step.status)}
                        </div>
                        <button 
                            className="block-menu-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                onDelete();
                            }}
                        >
                            ⋯
                        </button>
                    </div>
                </div>
            </div>

            {showDrawer && (
                <BlockDrawer 
                    step={step}
                    onUpdate={onUpdate}
                    onClose={() => setShowDrawer(false)}
                />
            )}
        </>
    );
};

export default FlowBlock; 